// extracted by mini-css-extract-plugin
export default {"container":"advertisers_container__LEu+E"};